import { Skeleton } from 'atp-react-ui';

export function Loader() {
  return <Skeleton className="h-[2.625rem] w-2/3 md:w-full" />;
}
